import {useEffect, useState, useRef, useCallback} from 'react';
import style from "../deposit/deposit.module.css";
import styles from "./withdraw.module.css";
import { setHeader } from '../../store/settings/settingsSlice';
import { useDispatch,useSelector } from 'react-redux';
import ng_icon from '../../assets/images/ng.svg'
import ghana_icon from '../../assets/images/ghanaflag.svg'
import usd_icon from '../../assets/images/usd.svg'
import bitcoinIcon from '../../assets/images/bitcoin.svg'
import ethIcon from "../../assets/images/ethereum-eth-logo.png";
import ltcIcon from "../../assets/images/litecoin-ltc-logo.svg";
import usdtIcon from "../../assets/images/tether-usdt-logo.svg";
import xrpIcon from "../../assets/images/xrp-xrp-logo.svg";
import dogeIcon from "../../assets/images/dogecoin-doge-logo.svg";
import trxIcon from "../../assets/images/tron-trx-logo.svg";
import bnbIcon from "../../assets/images/bnb-bnb-logo.svg";
import usdcIcon from "../../assets/images/usd-coin-usdc-logo.svg";
import solIcon from "../../assets/images/solana-sol-logo.svg";
import xlmIcon from "../../assets/images/stellar-xlm-logo.svg";
import successIcon from '../../assets/images/check-mark.svg'
import arrowCircleRight from '../../assets/images/arrow-circle-right.svg'
import arrow_left from '../../assets/images/arrow-left.svg'
import transactionTypeIcon from '../../assets/images/typeIcon.svg'
import spin_circle from '../../assets/images/Loader anim.png'
import cogoToast from "cogo-toast";
import moneyIcon from '../../assets/images/moneys.svg'
import { browserName } from "react-device-detect";
import { ArrowDown2} from "iconsax-react";
import { useNavigate } from 'react-router-dom';
import PinInput from "react-pin-input";
import Modal from '../modal/Modal';
import { addCryptoAccount, getCryptoAccounts, getCryptoCoins } from '../../store/settings/settingsActions';
import { fetchAstroName, getWalletBalance } from '../../store/wallet/walletActions';
import { InfoCircle } from "iconsax-react";
import Lottie from "lottie-react";
import loader from "../../assets/lottie/loader.json";
import { cryptoWithdrawal, cryptoWithdrawalByTag, generateSwapQuotation } from '../../store/crypto/cryptoActions';

const withdrawTypes = [
  { code: "FIAT", label: "Fiat" },
  { code: "CRYPTO", label: "Crypto" }
];


const coinIcons = {
  BTC: bitcoinIcon,
  ETH: ethIcon,
  LTC: ltcIcon,
  USDT: usdtIcon,
  XRP: xrpIcon,
  DOGE: dogeIcon,
  TRX: trxIcon,
  BNB: bnbIcon,
  USDC: usdcIcon,
  SOL: solIcon,
  XLM: xlmIcon,
};

const fiatAssetMeta = {
  NGN: {
    name: "Naira",
    symbol: "NGN",
    icon: ng_icon,
    pricePrefix: "₦",
  },
  GHS: {
    name: "Ghana Cedis",
    symbol: "CEDIS",
    icon: ghana_icon,
    pricePrefix: "GH₵",
  },
  USD: {
    name: "US Dollar",
    symbol: "USD",
    icon: usd_icon,
    pricePrefix: "$",
  },
};

const WithdrawPage = () => {
   const dispatch = useDispatch();
  const [location, setLocation] = useState("FIAT");
  const navigate = useNavigate();
  const [isCryptoModalOpen, setIsCryptoModalOpen] = useState(false);
  const {cryptocoins, loading} = useSelector((state) => state.settings)
  const allCryptoAccounts = useSelector((state) => state.settings.allCryptoAccounts);
  const walletData = useSelector((state) => state.wallet.data);
  const fiatWallets = walletData?.fiatWallets || [];
  const [isWalletAddressModal, setIsWalletAddressModal] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");
  const [openNetwork, setOpenNetwork] = useState(false);
  const [selectedNetworkName, setSelectedNetworkName] = useState("");  
  const [selectedNetworkId, setSelectedNetworkId] = useState("");
  const [isInternalTransferModal, setIsInternalTransferModal] = useState(false);
  const [withdrawalType, setWithdrawalType] = useState(""); // "walletAddress" or "internalTransfer"
  const [astroTag, setAstroTag] = useState("");
   const [amount, setAmount] = useState("");
   const [isInitiated, setIsInitiated] = useState(false);
    const [putPass, setPutPass] = useState(false);
    const [trPin, setTrPin] = useState(""); 
    let ele = useRef();
    const [disabled, setDisabled] = useState(true);
    const [isSuccessModal, setSuccessModal] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [accountName, setAccountName] = useState("");
    const [userNotFound, setUserNotFound] = useState(false);
    const [prevAstroTag, setPrevAstroTag] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const debounceRef = useRef(null);
    const [withdrawalFeeData, setWithdrawalFeeData] = useState(null);
    const [isLoadingFee, setIsLoadingFee] = useState(false);
    const [feeError, setFeeError] = useState("");

    const [showCryptoFavoritesDropdown, setShowCryptoFavoritesDropdown] = useState(false);
    const [isSelectingFromCryptoFavorites, setIsSelectingFromCryptoFavorites] = useState(false);
    const [showAddFavoriteModal, setShowAddFavoriteModal] = useState(false);
    const [newFavCryptoAddress, setNewFavCryptoAddress] = useState("");
    const [newFavCryptoName, setNewFavCryptoName] = useState("");
    const [newFavCryptoNetwork, setNewFavCryptoNetwork] = useState("");
    const [isSavingFav, setIsSavingFav] = useState(false);

    // Add these functions before your component return
const getAdaptiveDelay = useCallback((prev, current) => {
  let TYPING_SPEED_DELAY = {
    fast: 800,
    moderate: 500,
    slow: 300,
  };

  const diff = current.length - prev.length;
  const typingSpeed = Math.abs(diff);

  if (typingSpeed > 3) return TYPING_SPEED_DELAY.fast;
  if (typingSpeed > 1) return TYPING_SPEED_DELAY.moderate;
  return TYPING_SPEED_DELAY.slow;
}, []);


const fetchAstroAccountName = useCallback(async (tag) => {
  setIsLoading(true);
  setUserNotFound(false); // reset before new fetch
  dispatch(fetchAstroName({ name: tag })).then((res) => {
    if (res?.type === "fetchAstroName/fulfilled") {
      setIsLoading(false);
      setAccountName(`${res.payload.data.data.firstname} ${res.payload.data.data.lastname}`)
    } else if (res?.type === "fetchAstroName/rejected") {
      setIsLoading(false);
      setAccountName("")
      setUserNotFound(true);
    }
  });
}, [dispatch]);

useEffect(() => {
  if (!astroTag) {
    setAccountName("");
    setUserNotFound(false);
    return;
  }

  const delay = getAdaptiveDelay(prevAstroTag, astroTag);
  setPrevAstroTag(astroTag);

  if (debounceRef.current) clearTimeout(debounceRef.current);

  debounceRef.current = setTimeout(() => {
    fetchAstroAccountName(astroTag);
  }, delay);

  return () => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
  };
}, [astroTag, fetchAstroAccountName, getAdaptiveDelay, prevAstroTag]);

    const mappedCryptoAssets = (cryptocoins || []).map(asset => ({
    code: asset.currency?.toUpperCase(),
    id: asset.quidaxUserId,
    coin_type_id: asset.coin_type_id,
    name: asset.name,
    symbol: asset.currency?.toUpperCase(),
    icon: coinIcons[asset.currency?.toUpperCase()] || bitcoinIcon,
    price: `${asset.currency?.toUpperCase()} ${asset.balance || "0.00"}`,
    balance: asset.balance,
    change: asset.price_change_percentage
        ? `${asset.price_change_percentage > 0 ? "+" : ""}${asset.price_change_percentage.toFixed(2)}%`
        : "0.00%",
    changeUp: asset.price_change_percentage > 0,
    }));

    const mappedFiatAssets = fiatWallets
    .filter(wallet => wallet.is_active)
    .map(wallet => {
        const code = wallet.Currency?.code;
        const meta = fiatAssetMeta[code] || {};
        return {
        code,
        name: meta.name || wallet.Currency?.name || code,
        symbol: meta.symbol || code,
        icon: meta.icon,
        price: `${meta.pricePrefix || ""}${parseFloat(wallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        id: wallet.id,
        };
    })

    const [selectedCrypto, setSelectedCrypto] = useState(null);

    // Remove the static availableNetworks array and replace with this:
    const availableNetworks = selectedCrypto ? 
    (cryptocoins.find(coin => coin.currency?.toUpperCase() === selectedCrypto.code)?.networks || []).map(network => ({
        id: network.id,
        name: network.name || network.id.toUpperCase(),
    })) : [];
        

    const handleNetwork = (e, id) => {
        setOpenNetwork(false);
        setSelectedNetworkName(e.target.textContent);
        setSelectedNetworkId(id); // for payload
    };

    const toggleNetwork = () => {
       setOpenNetwork((prevNetwork) => {
        return !prevNetwork;
     });
    };


    // Add this function before the return statement
    const fetchWithdrawalFee = useCallback(async (amountValue) => {
    if (!amountValue || !selectedNetworkId || !selectedCrypto) {
        setWithdrawalFeeData(null);
        setFeeError("");
        return;
    }
    console.log(selectedNetworkId)
    setIsLoadingFee(true);
    setFeeError("");

    try {
        const quotationData = {
        from_currency: selectedCrypto.symbol.toLowerCase(),
        to_currency: selectedCrypto.symbol.toLowerCase(),
        from_amount: amountValue.toString(),
        network: selectedNetworkId,
        quidaxUserId: selectedCrypto.id,
        transaction_type: "crypto_withdrawal"
        };

        const result = await dispatch(generateSwapQuotation(quotationData));
        
        if (result.type === "generateSwapQuotation/fulfilled") {
        setWithdrawalFeeData(result.payload.data);
        setFeeError("");
        } else {
        setWithdrawalFeeData(null);
        setFeeError("Unable to calculate fee. Please try again.");
        }
    } catch (error) {
        console.error("Fee calculation error:", error);
        setWithdrawalFeeData(null);
        setFeeError("Unable to calculate fee");
    } finally {
        setIsLoadingFee(false);
    }
    }, [dispatch, selectedNetworkId, selectedCrypto]);

    // Add debounce for fee calculation
    const debouncedFeeRef = useRef(null);

    const debouncedFetchFee = useCallback((amountValue) => {
    if (debouncedFeeRef.current) {
        clearTimeout(debouncedFeeRef.current);
    }
    debouncedFeeRef.current = setTimeout(() => {
        fetchWithdrawalFee(amountValue);
    }, 800);
    }, [fetchWithdrawalFee]);

    const handleSelectCryptoFromFavorites = (favorite) => {
        setIsSelectingFromCryptoFavorites(true);
        
       // Find the network in availableNetworks by matching the network name/id from favorite
        const matchedNetwork = availableNetworks.find(
            network => network.id?.toLowerCase() === favorite.network?.toLowerCase()
        );
        if (matchedNetwork) {
            setSelectedNetworkName(matchedNetwork.name);
            selectedNetworkId(matchedNetwork.id);
        }
        
        setTimeout(() => setIsSelectingFromCryptoFavorites(false), 100);
    };

    const handleSaveCryptoFavorite = async () => {
    if (!newFavCryptoAddress || !newFavCryptoName || !selectedCrypto || !selectedNetworkId) {
        cogoToast.error("Please fill all required fields", { position: "top-right" });
        return;
    }

    setIsSavingFav(true);
    
    try {
        const payload = {
        walletAddress: newFavCryptoAddress,
        coinType: selectedCrypto.code,
        network: selectedNetworkId,
        coinName: newFavCryptoName
        };
        
        const result = await dispatch(addCryptoAccount(payload));
        
        if (result.type === "addCryptoAccount/fulfilled") {
        setNewFavCryptoAddress("");
        setNewFavCryptoName("");
        setNewFavCryptoNetwork("");
        setShowAddFavoriteModal(false);
        // The dispatch already calls getCryptoAccounts internally
        }
    } catch (error) {
        console.error("Error saving favorite:", error);
    } finally {
        setIsSavingFav(false);
    }
    };


    const handleClearCryptoFavorite = () => {
    setWalletAddress("");
    setSelectedNetworkName("");
    setSelectedNetworkId("");
    setShowCryptoFavoritesDropdown(false);
    setIsSelectingFromCryptoFavorites(false);
    };

    // Add click outside handler for favorites dropdown
    useEffect(() => {
    const handleClickOutside = (event) => {
        if (event.target.id !== "cryptoFavoritesBtn" && !event.target.closest('[data-crypto-favorites]')) {
        setShowCryptoFavoritesDropdown(false);
        }
    };
    
    if (showCryptoFavoritesDropdown) {
        document.addEventListener("mousedown", handleClickOutside);
    }
    
    return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showCryptoFavoritesDropdown]);

   const handleWithdrawal = async () => {
    setIsOpen(true);
    setPutPass(false);
    // Wallet Address Withdrawal
    if (withdrawalType === "walletAddress") {
        try {
        const payload = {
            coinTypeId: selectedCrypto?.coin_type_id,
            amount: parseFloat(amount),
            coinNetwork: selectedNetworkId,
            walletAddress: walletAddress,
            transactionPin: trPin
        };
        const res = await dispatch(cryptoWithdrawal(payload));
        setIsOpen(false);
        if (res?.type === "cryptoWithdrawal/fulfilled") {
            setSuccessModal(true);
            // Optionally reset fields here
            setAmount("");
            setWalletAddress("");
            setSelectedNetworkName("");
            setTrPin("");
        } else {
            // Handle error (show toast, etc.)
        }
        } catch (err) {
        setIsOpen(false);
        // Handle error (show toast, etc.)
        }
        return;
    }

   if (withdrawalType === "internalTransfer") {
    // Internal Transfer via AstroTag (cryptoWithdrawalByTag)
    try {
      const payload = {
        coinTypeId: selectedCrypto?.coin_type_id,
        amount: parseFloat(amount),
        recipientTag: astroTag,
        transactionPin: trPin
      };
      const res = await dispatch(cryptoWithdrawalByTag(payload));
      setIsOpen(false);
      if (res?.type === "cryptoWithdrawalByTag/fulfilled") {
        setSuccessModal(true);
        setAmount("");
        setAstroTag("");
        setAccountName("");
        setTrPin("");
      } else {
        // Handle error (show toast, etc.)
      }
    } catch (err) {
      setIsOpen(false);
      // Handle error (show toast, etc.)
    }
    return;
  }

    // Internal Transfer (existing logic)
    setTimeout(() => {
        setIsOpen(false);
        setSuccessModal(true);
    }, 3000);
    };

  useEffect(() => {
  let handler = (e) => {
    if (e.target.id !== "account" && e.target.id !== "network") {
      setOpenNetwork(false);
    } else if (e.target.id === "network") {
      toggleNetwork();
    }
    if (e.target.id === "networkDrop") {
      setOpenNetwork(true);
        }
    };
    document.addEventListener("mousedown", handler);

    return () => {
        document.removeEventListener("mousedown", handler);
    };
    }, []);

    useEffect(() => {
        if (trPin !== "" && trPin.length === 5) {
            setDisabled(false);
        } else {
        setDisabled(true);
        }
    }, [trPin]);

    useEffect(() => {
        return () => {
            if (debouncedFeeRef.current) {
            clearTimeout(debouncedFeeRef.current);
            }
        };
        }, []);
    
    useEffect(() => {
        dispatch(setHeader("Withdraw"));    
        dispatch(getCryptoCoins())    
        dispatch(getWalletBalance());
        dispatch(getCryptoAccounts())
     }, [dispatch]);
    
    return ( 
        <>
    
       <Modal
        title={`Withdraw ${selectedCrypto?.name || ""}`}
        minWidth="40%"
        canClose
        modalOpen={isCryptoModalOpen}
        setModalOpen={setIsCryptoModalOpen}
        >
        <div style={{ marginTop: '18px', textAlign: 'center' }}>
            <p style={{
            color: '#B6B6B6',
            fontSize: 14,
            marginBottom: 32,
            marginTop: 0,
            fontWeight: 400,
            }}>
          Please select one of the options below to withdraw from
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
            <div 
            className={style.cryptoModalOption}
             onClick={() => {
                setIsCryptoModalOpen(false);
                setIsWalletAddressModal(true);
                setSelectedNetworkName("");  
                setWalletAddress("");
                setAmount("");
                setIsInitiated(false);
            }}
            >
                <div className={style.cryptoModalIconWrap}>
                {/* Example SVG icon for wallet */}
                <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><path d="M2 7.5A2.5 2.5 0 0 1 4.5 5h15A2.5 2.5 0 0 1 22 7.5v9A2.5 2.5 0 0 1 19.5 19h-15A2.5 2.5 0 0 1 2 16.5v-9Z" stroke="#40196D" strokeWidth="1.5"/><circle cx="17" cy="12" r="1" fill="#40196D"/></svg>
                </div>
                <div>
                <div className={style.cryptoModalOptionTitle}>Wallet Address</div>
                <div className={style.cryptoModalOptionDesc}>Send crypto to other wallet address</div>
                </div>
                <div className={style.cryptoModalArrow}>
                     <img src={arrowCircleRight} alt="arrow right" />
                </div>
            </div>
            <div
             className={style.cryptoModalOption}
                 onClick={() => {
                    setIsCryptoModalOpen(false);
                    setIsInternalTransferModal(true);
                    setAstroTag("");
                    setAmount("");
                    setIsInitiated(false);
                }}
             >
                <div className={style.cryptoModalIconWrap}>
                {/* Example SVG icon for internal transfer */}
                   <svg width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="6" cy="12" r="2" stroke="#40196D" strokeWidth="1.5"/><circle cx="18" cy="6" r="2" stroke="#40196D" strokeWidth="1.5"/><circle cx="18" cy="18" r="2" stroke="#40196D" strokeWidth="1.5"/><path d="M7.76 10.62l2.48-1.24M7.76 13.38l2.48 1.24M15.52 7.24l-2.48 1.24M15.52 16.76l-2.48-1.24" stroke="#40196D" strokeWidth="1.5"/></svg>
                </div>
                <div>
                <div className={style.cryptoModalOptionTitle}>Internal Transfer</div>
                <div className={style.cryptoModalOptionDesc}>Send crypto to a Astro user</div>
                </div>
                <div className={style.cryptoModalArrow}>
                    <img src={arrowCircleRight} alt="arrow right" />
                </div>
            </div>
            </div>
        </div>
        </Modal>

        {/* ===== Wallet Address Withdraw MODAL */}
        <Modal title={`Withdraw ${selectedCrypto?.name || ""}`} minWidth='40%' canClose modalOpen={isWalletAddressModal} setModalOpen={setIsWalletAddressModal}>
        {!isInitiated ? (
            <div style={{marginTop: '25px'}}>
            {/* From Wallet */}
            <div className={style.labelPut}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <label htmlFor="wallet">From Wallet</label>
                <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>
                    Bal: {selectedCrypto?.symbol} {selectedCrypto?.balance || "0.00"}
                </p>
                </div>
                <div className={style.payoutDiv}>
                <img src={selectedCrypto?.icon} alt={selectedCrypto?.name} width={24} height={24} />
                <p>{selectedCrypto?.symbol}</p>
                </div>
            </div>

           {/* Select Network */}
                <div className={styles.labelPut}>
                <label htmlFor="network">Select Network</label>
                <div className={styles.select} style={{marginTop: '10px'}}>
                    <div 
                    id="network"
                    name="network" 
                    className={styles.selectInput}
                    >
                    <input
                        type="text"
                        disabled={browserName === "Firefox" ? false : true}
                        value={selectedNetworkName}
                        placeholder="Select Network"
                        style={{pointerEvents: "none"}}
                    />
                    <ArrowDown2
                        style={{
                        transform:
                            openNetwork === true
                            ? "translateY( -50%) rotate(-540deg)"
                            : "translateY( -50%) rotate(0deg)",
                        pointerEvents: "none",
                        }}
                        className={styles.dropDown}
                        size="20"
                        color="#909090"
                        variant="Bold"
                    />
                    </div>
                    <div
                    style={{
                        height: openNetwork === true ? "fit-content" : "0px",
                        maxHeight: 'fit-content',
                    }}
                    className={styles.option}
                    >
                    {availableNetworks && availableNetworks.length > 0 ? (
                        availableNetworks.map((network, index) => (
                        <p
                            id="networkDrop"
                            key={network.id}
                            onClick={(e) => handleNetwork(e, network.id)}
                            style={{
                            borderBottom: `${index !== availableNetworks.length - 1 ? '1px #90909042 solid': ''}`
                            }}
                        >
                            {network.name}
                        </p>
                        ))
                    ) : (
                        <p>No networks available</p>
                    )}
                    </div>
                </div>
                </div>

                {/* Wallet Address */}
                <div className={style.labelPut}>
                <label htmlFor="walletAddress">Wallet Address<span style={{color:'#FF0000'}}>*</span></label>
                <div className={style.input}>
                    <input
                    type="text"
                    name="walletAddress"
                    placeholder="Paste Wallet Address"
                    value={walletAddress}
                    onChange={(e) => setWalletAddress(e.target.value)}
                    />
                </div>
                
                {/* Favorites Section */}
                <div style={{position: 'relative', width: '100%'}}>
                    <p 
                    id="cryptoFavoritesBtn"
                    onClick={() => setShowCryptoFavoritesDropdown(!showCryptoFavoritesDropdown)}
                    style={{
                        color: '#40196D', 
                        textDecoration: 'underline', 
                        textAlign: 'right', 
                        fontSize: 12, 
                        margin: '8px 0 0 0', 
                        cursor: 'pointer'
                    }}
                    >
                    {showCryptoFavoritesDropdown ? 'Hide Favorites' : 'Select from my Favorites'}
                    </p>
                    
                    {/* Favorites Dropdown */}
                    {showCryptoFavoritesDropdown && (
                    <div 
                        data-crypto-favorites
                        style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        background: '#ffffff',
                        border: '1px solid #e8e8e8',
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        maxHeight: '250px',
                        overflowY: 'auto',
                        marginTop: '4px'
                        }}
                    >
                       {allCryptoAccounts?.cryptotAccounts?.filter(fav => fav.coin_type?.toLowerCase() === selectedCrypto?.code?.toLowerCase()).length > 0 ? (
                        <>
                            {/* Clear Selection Option */}
                            <p
                            onClick={handleClearCryptoFavorite}
                            style={{
                                borderBottom: '2px solid #f0f0f0',
                                padding: '12px 16px',
                                cursor: 'pointer',
                                margin: 0,
                                fontSize: '12px',
                                color: '#ff4757',
                                fontWeight: '600',
                                fontStyle: 'italic'
                            }}
                            >
                            ✕ Clear Selection (Enter manually)
                            </p>
                            
                            {/* Saved Crypto Addresses */}
                           {allCryptoAccounts?.cryptotAccounts
                                ?.filter(fav => fav.coin_type?.toLowerCase() === selectedCrypto?.code?.toLowerCase())
                                .map((favorite, index) => (
                            <p
                                key={favorite.id}
                                onClick={() => {
                                handleSelectCryptoFromFavorites(favorite);
                                setShowCryptoFavoritesDropdown(false);
                                }}
                                style={{
                                borderBottom: `${index !== allCryptoAccounts.cryptotAccounts.length - 1 ? '1px #90909042 solid': ''}`,
                                padding: '12px 16px',
                                cursor: 'pointer',
                                margin: 0,
                                fontSize: '13px',
                                lineHeight: '1.6'
                                }}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                <strong>{favorite.coin_name}</strong> - {favorite.network}
                                <br />
                                <span style={{fontSize: '11px', color: '#666', wordBreak: 'break-all'}}>
                                {favorite.wallet_address}
                                </span>
                            </p>
                            ))}
                            
                            {/* Add New Favorite Option */}
                            <p
                            onClick={() => setShowAddFavoriteModal(true)}
                            style={{
                                borderTop: '2px solid #f0f0f0',
                                padding: '12px 16px',
                                cursor: 'pointer',
                                margin: 0,
                                fontSize: '12px',
                                color: '#40196D',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                backgroundColor: '#f8f9fa'
                            }}
                            >
                            + Add New Address to Favorites
                            </p>
                        </>
                        ) : (
                        <>
                            <p style={{padding: '12px 16px', margin: 0, color: '#909090', fontSize: '12px'}}>
                            No saved addresses yet
                            </p>
                            
                            {/* Add New Favorite Option */}
                            <p
                            onClick={() => setShowAddFavoriteModal(true)}
                            style={{
                                borderTop: '1px solid #f0f0f0',
                                padding: '12px 16px',
                                cursor: 'pointer',
                                margin: 0,
                                fontSize: '12px',
                                color: '#40196D',
                                fontWeight: '600',
                                fontStyle: 'italic',
                                backgroundColor: '#f8f9fa'
                            }}
                            >
                            + Add Address to Favorites
                            </p>
                        </>
                        )}
                    </div>
                    )}
                </div>
                </div>

            {/* Amount */}
            <div className={style.labelPut}>
                <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                <div className={style.input} style={{position: 'relative'}}>
                <input
                    type="number"
                    name="amount"
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => {
                        const value = e.target.value < 0 ? 0 : e.target.value;
                        setAmount(value);
                        if (value > 0 && selectedNetworkId) {
                            debouncedFetchFee(value);
                        } else {
                            setWithdrawalFeeData(null);
                            setFeeError("");
                        }
                    }}
                />
                {/* Percentage buttons */}
                <div style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    gap: '8px'
                }}>
                    {['10%', '25%', '50%', '75%', 'Max'].map((percent) => (
                    <button
                        key={percent}
                        type="button"
                        style={{
                        background: '#f5f5f5',
                        border: 'none',
                        borderRadius: '4px',
                        padding: '4px 8px',
                        fontSize: '12px',
                        color: '#666',
                        cursor: 'pointer'
                        }}
                       onClick={() => {
                        // Calculate percentage of balance
                        const balance = parseFloat(selectedCrypto?.balance || 0);
                        let calculatedAmount;
                        
                        if (percent === 'Max') {
                            calculatedAmount = balance;
                        } else {
                            const percentage = parseInt(percent) / 100;
                            calculatedAmount = balance * percentage;
                        }
                        
                        const formattedAmount = calculatedAmount.toFixed(6);
                        setAmount(formattedAmount);
                        
                        // Trigger fee calculation
                        if (formattedAmount > 0 && selectedNetworkId) {
                            debouncedFetchFee(formattedAmount);
                        } else {
                            setWithdrawalFeeData(null);
                            setFeeError("");
                        }
                        }}
                    >
                        {percent}
                    </button>
                    ))}
                </div>
                </div>
            </div>


        {withdrawalFeeData && (
        <div style={{
            marginTop: '15px',
            padding: '12px',
            backgroundColor: '#F5F3F7',
            borderRadius: '8px',
            fontSize: '14px'
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span style={{ color: '#909090' }}>Network Fee:</span>
            <span style={{ color: '#212121', fontWeight: 600 }}>
                {selectedCrypto?.symbol} {withdrawalFeeData.fee_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
            </span>
            </div>
           
            <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #E0E0E0', paddingTop: '8px' }}>
            <span style={{ color: '#212121', fontWeight: 600 }}>Total Debit:</span>
            <span style={{ color: '#40196D', fontWeight: 600 }}>
                {selectedCrypto?.symbol} {withdrawalFeeData.debit_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
            </span>
            </div>
        </div>
        )}

            {feeError && (
            <p style={{ color: '#FF0000', fontSize: '12px', marginTop: '8px' }}>
                {feeError}
            </p>
            )}

            {isLoadingFee && (
            <p style={{ color: '#40196D', fontSize: '12px', marginTop: '8px' }}>
                Calculating fee...
            </p>
            )}

           <button 
            disabled={
                !amount || 
                !walletAddress || 
                !selectedNetworkName || 
                isLoadingFee ||
                !withdrawalFeeData ||
                (withdrawalFeeData && parseFloat(withdrawalFeeData.debit_amount) > parseFloat(selectedCrypto?.balance || 0))
            } 
            onClick={() => setIsInitiated(true)} 
            style={{marginTop: '20px'}} 
            className={style.save}
            >
            {isLoadingFee ? "Calculating fee..." : "Proceed"}
            </button>

            {withdrawalFeeData && parseFloat(withdrawalFeeData.debit_amount) > parseFloat(selectedCrypto?.balance || 0) && (
            <div style={{
                backgroundColor: '#FFE0E0',
                color: '#FF0000',
                padding: '10px 12px',
                borderRadius: '6px',
                fontSize: '12px',
                marginBottom: '15px'
            }}>
                Insufficient balance. You need {selectedCrypto?.symbol} {(withdrawalFeeData.debit_amount - parseFloat(selectedCrypto?.balance || 0)).toLocaleString(undefined, { maximumFractionDigits: 8 })} more.
            </div>
            )}

            </div>
        ) : (
            <div style={{marginTop: '20px'}}>
            <div onClick={() => setIsInitiated(false)} style={{
                width: '20px', 
                height: '20px', 
                background: '#40196d1a', 
                borderRadius: '50%', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                cursor: 'pointer'
            }}>
                <img src={arrow_left} alt="arrow left" />
            </div>

            <div style={{background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px'}}>
                <p style={{color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0}}>
                Please check transaction details
                </p>

                {/* From Wallet Info */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={selectedCrypto?.icon} alt={selectedCrypto?.name} width={24} height={24} />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.name} Wallet
                    </p>
                </div>
                </div>

                {/* Send to */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Send to</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {walletAddress}
                    </p>
                </div>
                </div>

                {/* Transfer Type */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Transfer Type</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    To Wallet Address
                    </p>
                </div>
                </div>

               {/* Network Info */}
                    <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                    <div>
                        <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                    </div>
                    <div>
                        <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Network</h6>
                        <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                        {selectedNetworkName || "Not Selected"}
                        </p>
                    </div>
                </div>

           <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={moneyIcon} alt='feeIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0}}>Network Fee</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.symbol} {withdrawalFeeData?.fee_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
                    </p>
                </div>
                </div>

            <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
            <div>
                <img src={moneyIcon} alt='totalIcon' />
            </div>
            <div>
                <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14, margin: 0}}>Total Debit</h6>
                <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '600', fontSize: 14}}>
                {selectedCrypto?.symbol} {withdrawalFeeData?.debit_amount?.toLocaleString(undefined, { maximumFractionDigits: 8 }) || "0"}
                </p>
            </div>
            </div>

                {/* Amount */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={moneyIcon} alt='moneyIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Amount</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.symbol} {amount}
                    </p>
                </div>
                </div>

                {/* Network Fee */}
               {/* <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={moneyIcon} alt='moneyIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Network Fee</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.symbol} 0.001
                    </p>
                </div>
                </div> */}
            </div>
            
            <button onClick={() => {
                // Handle wallet address withdrawal
                setIsWalletAddressModal(false);
                setWithdrawalType("walletAddress");
                setPutPass(true);
                setTrPin("");
                ele.clear();
            }} style={{marginTop: '30px'}} className={style.save}>
                Proceed
            </button>
            </div>
        )}
        </Modal>

        {/* Add to Favorites Modal */}
            <Modal 
            title="Save Wallet Address" 
            minWidth="40%" 
            canClose 
            modalOpen={showAddFavoriteModal} 
            setModalOpen={setShowAddFavoriteModal}
            >
            <div style={{marginTop: '25px'}}>
                <div className={style.labelPut}>
                <label htmlFor="favName">Nickname (e.g., 'My Hardware Wallet')<span style={{color:'#FF0000'}}>*</span></label>
                <div className={style.input}>
                    <input
                    type="text"
                    name="favName"
                    placeholder="Enter a name for this address"
                    value={newFavCryptoName}
                    onChange={(e) => setNewFavCryptoName(e.target.value)}
                    />
                </div>
                </div>

                <div className={style.labelPut}>
                <label htmlFor="favNetwork">Network<span style={{color:'#FF0000'}}>*</span></label>
                <div className={style.input}>
                    <input
                    type="text"
                    name="favNetwork"
                    placeholder="Network"
                    disabled
                    value={selectedNetworkName}
                    />
                </div>
                </div>

                <div className={style.labelPut}>
                <label htmlFor="favAddress">Wallet Address<span style={{color:'#FF0000'}}>*</span></label>
                <div className={style.input}>
                    <input
                    type="text"
                    name="favAddress"
                    placeholder="Wallet address"
                    value={newFavCryptoAddress}
                    onChange={(e) => setNewFavCryptoAddress(e.target.value)}
                    style={{wordBreak: 'break-all'}}
                    />
                </div>
                </div>

                <p style={{fontSize: '12px', color: '#909090', marginTop: '12px'}}>
                Coin: {selectedCrypto?.name} ({selectedCrypto?.symbol})
                </p>

                <button 
                disabled={!newFavCryptoAddress || !newFavCryptoName || !selectedNetworkName || isSavingFav}
                onClick={handleSaveCryptoFavorite}
                style={{marginTop: '20px'}} 
                className={style.save}
                >
                {isSavingFav ? "Saving..." : "Save Address"}
                </button>
            </div>
            </Modal>

        {/* ===== Internal Transfer Withdraw MODAL */}
        <Modal title={`Withdraw ${selectedCrypto?.name || ""}`} minWidth='40%' canClose modalOpen={isInternalTransferModal} setModalOpen={setIsInternalTransferModal}>
        {!isInitiated ? (
            <div style={{marginTop: '25px'}}>
                {/* From Wallet */}
                <div className={style.labelPut}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <label htmlFor="wallet">From</label>
                    <p style={{margin: '0px', color: '#40196D', fontWeight: 600, fontSize: 14}}>
                        Balance: {selectedCrypto?.balance || "0.00"} {selectedCrypto?.symbol}
                    </p>
                    </div>
                    <div className={style.payoutDiv}>
                    <img src={selectedCrypto?.icon} alt={selectedCrypto?.name} width={24} height={24} />
                    <p>{selectedCrypto?.name}</p>
                    </div>
                </div>

                {/* Amount with percentage buttons */}
                <div className={style.labelPut}>
                    <label htmlFor="amount">Amount<span style={{color:'#FF0000'}}>*</span></label>
                    <div className={style.input} style={{position: 'relative'}}>
                    <input
                        type="number"
                        name="amount"
                        placeholder="0.00"
                        value={amount}
                        onChange={(e) => {
                        setAmount(e.target.value < 0 ? 0 : e.target.value);
                        }}
                    />
                    {/* Percentage buttons */}
                    <div style={{
                        position: 'absolute',
                        right: '12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        gap: '8px'
                    }}>
                        {['10%', '25%', '50%', '75%', 'Max'].map((percent) => (
                        <button
                            key={percent}
                            type="button"
                            style={{
                            background: '#f5f5f5',
                            border: 'none',
                            borderRadius: '4px',
                            padding: '4px 8px',
                            fontSize: '12px',
                            color: '#666',
                            cursor: 'pointer'
                            }}
                            onClick={() => {
                            // Calculate percentage of balance
                            const balance = parseFloat(selectedCrypto?.balance || 0);
                            if (percent === 'Max') {
                                setAmount(balance);
                            } else {
                                const percentage = parseInt(percent) / 100;
                                setAmount((balance * percentage).toFixed(6));
                            }
                            }}
                        >
                            {percent}
                        </button>
                        ))}
                    </div>
                    </div>
                </div>

               {/* Astro Tag */}
                <div className={style.labelPut}>
                    <label htmlFor="astroTag">Astro Tag<span style={{color:'#FF0000'}}>*</span></label>
                    <div className={style.input}>
                    <input
                        type="text"
                        name="astroTag"
                        placeholder="Enter astro username"
                        value={astroTag}
                        onChange={(e) => setAstroTag(e.target.value)}
                    />
                    </div>
                    {userNotFound && (
                    <div className={style.info_div}>
                        <InfoCircle size="20" variant="Bold" color="#F40000" />
                        <p style={{margin: '0px', color: '#F40000'}}>User not found. Please check the AstroTag.
                        </p>
                    </div>
                    )}
                </div>

                {/* Add Astro Account Name field */}
                <div className={style.labelPut}>
                    <label htmlFor="accountName">Astro Account Name</label>
                    <div className={style.input}>
                        <input
                            type="text"
                            name="accountName"
                            placeholder="Astro Account Name"
                            disabled
                            value={accountName}
                        />
                    {isLoading && (
                        <div className={styles.lottieWrapDrop}>
                        <Lottie
                            style={{
                            width: "70px",
                            height: "70px",
                            color: "#fff",
                            padding: "0px",
                            margin: "0px",
                            }}
                            animationData={loader}
                            loop={true}
                        />
                        </div>
                    )}
                    </div>
                </div>


                <button 
                    disabled={!amount || !astroTag || !accountName || isLoading} 
                    onClick={() => setIsInitiated(true)} 
                    style={{marginTop: '20px'}} 
                    className={style.save}
                >
                    Proceed
                </button>
            </div>
        ) : (
            <div style={{marginTop: '20px'}}>
            <div onClick={() => setIsInitiated(false)} style={{
                width: '20px', 
                height: '20px', 
                background: '#40196d1a', 
                borderRadius: '50%', 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                cursor: 'pointer'
            }}>
                <img src={arrow_left} alt="arrow left" />
            </div>

            <div style={{background: '#F5F3F7', marginTop: '20px', borderRadius: '20px', padding: '25px 25px'}}>
                <p style={{color: '#212121', fontWeight: '400', textAlign: 'left', fontSize: 14, marginBottom: 0}}>
                Please check transaction details
                </p>

                {/* From Wallet Info */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={selectedCrypto?.icon} alt={selectedCrypto?.name} width={24} height={24} />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>From Wallet</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.name} Wallet
                    </p>
                </div>
                </div>

                {/* Send to */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Send to</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {astroTag}
                    </p>
                </div>
                </div>

                {/* Account name */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={transactionTypeIcon} alt='accountIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Account Name</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {accountName}
                    </p>
                </div>
                </div>

                {/* Transfer Type */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={transactionTypeIcon} alt='transactionTypeIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Transfer Type</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    Internal Transfer
                    </p>
                </div>
                </div>

                {/* Amount */}
                <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={moneyIcon} alt='moneyIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Amount</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.symbol} {amount}
                    </p>
                </div>
                </div>

                {/* Network Fee - Usually 0 for internal transfers */}
                {/* <div style={{marginTop: '20px', display: 'flex', gap: '15px', alignItems: 'center'}}>
                <div>
                    <img src={moneyIcon} alt='moneyIcon' />
                </div>
                <div>
                    <h6 style={{color: '#90909080', fontWeight: '400', fontSize: 14}}>Network Fee</h6>
                    <p style={{marginBottom: 0, marginTop: '5px', textAlign: 'left', color: '#212121', fontWeight: '400', fontSize: 14}}>
                    {selectedCrypto?.symbol} 0.00
                    </p>
                </div>
                </div> */}
            </div>
            
            <button onClick={() => {
                // Handle internal transfer
                setIsInternalTransferModal(false);
                setWithdrawalType("internalTransfer");
                setPutPass(true);
                setTrPin("");
                ele.clear();
            }} style={{marginTop: '30px'}} className={style.save}>
                Proceed
            </button>
            </div>
        )}
        </Modal>

         {/* =========================== THE LOADING MODAL FOR PROCESSING WITHDRAWAL REQUEST  */}
      <Modal
        canClose={false}
        modalOpen={isOpen}
        setModalOpen={setIsOpen}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={spin_circle} alt="spin circle" className={style.animate_spin} />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Initiating Withdrawal</h4>
             
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                  Please wait...
                </p>
               
            </div>
        </div>
      </Modal>

       {/* ======== THE MODAL TO STATE THAT WITHDRAWAL IS SUCCCESSFUL */}
        <Modal
        canClose={true}
        modalOpen={isSuccessModal}
        setModalOpen={setSuccessModal}
      >
        <div>
            <div style={{display: 'flex', justifyContent: 'center', marginTop: '25px'}}>
                <img src={successIcon} alt="check mark circle" />
            </div>

            <div>
                <h4 style={{color: '#40196D', fontWeight: '600', marginTop: '25px'}}>Withdrawal Successful</h4>
            
                <p style={{color: '#B6B6B6', maxWidth:'300px', margin: 'auto', marginTop: '15px'}}>
                    Your withdrawal request has been successfully processed.
                </p>
            </div>

            <button onClick={() => setSuccessModal(false)} style={{marginTop: '20px'}} className={style.save}>
               Continue
            </button>

        </div>

        </Modal>

         {/* MODAL FOR TRANSACTION PIN */}
        <Modal canClose={true} modalOpen={putPass} setModalOpen={setPutPass}>
          <div className={style.setTrPin}>
            <h2 className={style.pinHead}>Transaction Pin</h2>
            <p>Please input your transaction pin</p>
            <div className={style.inputs2}>
              <PinInput
                length={5}
                initialValue=""
                secret={true}
                ref={(n) => {
                  ele = n;
                }}
                onChange={(value, index) => {
                  setTrPin(value);
                }}
                type="numeric"
                inputMode="number"
                style={{ padding: "10px", margin: "0 auto 0 auto" }}
                inputStyle={{ border: "1px solid", borderColor: "#909090" }}
                inputFocusStyle={{
                  border: "2px solid",
                  borderColor: "#40196D",
                }}
                onComplete={(value, index) => {
                  setTrPin(value);
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
            </div>
            <button
              disabled={disabled}
              className={style.save}
              onClick={handleWithdrawal}
            >
              Withdraw Funds
            </button>
          </div>
        
      </Modal>
      

        <div
            className={style.cashTabs}
        >
            <ul>
               {withdrawTypes.map((type) => {
                const isSelected = location === type.code;
                return (
                    <li
                    key={type.code}
                    onClick={() => setLocation(type.code)}
                    style={{
                        borderBottom: isSelected
                        ? "3px #40196D solid"
                        : "0px #90909039 solid",
                    }}
                    >
                    <div>
                        <p
                        style={{
                            color: isSelected ? "#40196D" : "#C1C1C1",
                        }}
                        >
                        {type.label}
                        </p>
                    </div>
                    </li>
                );
                })}
            </ul>
        </div>

    
          {location === "FIAT" && (
            <>
                <p className={style.depositSubtitle}>Select the asset you want to withdraw.</p>
                 <div className={style.fiatAssetsList}>
      {mappedFiatAssets.length === 0 ? (
        <div style={{ width: "100%", textAlign: "center", padding: "40px 0", color: "#909090" }}>
          No fiat wallets found.
        </div>
      ) : (
      mappedFiatAssets.map(asset => (
          <div
            className={style.fiatAssetCard}
            key={asset.code}
            onClick={
              asset.comingSoon
                ? undefined
                : () => navigate(`/withdraw-with-fiat?currency=${asset.code}`)
            }
            style={{
              cursor: asset.comingSoon ? "not-allowed" : "pointer",
              opacity: asset.comingSoon ? 0.6 : 1,
              position: "relative"
            }}
          >
            <div className={style.fiatAssetInfo}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#FFFFFF',
                justifyContent: 'center',
              }}>
                <img src={asset.icon} alt={asset.name} className={style.fiatAssetIcon} />
              </div>
              <div>
                <div className={style.fiatAssetName}>{asset.name}</div>
                <div className={style.fiatAssetSymbol}>{asset.symbol}</div>
              </div>
            </div>
            <div className={style.fiatAssetPriceBlock}>
              <div className={style.fiatAssetPrice}>{asset.price}</div>
            </div>
          </div>
        ))
      )}
    </div>
            </>
        )}


      
        {location === "CRYPTO" && (
                <>
                    <p className={style.depositSubtitle}>Select the asset you want to withdraw from.</p>
                    <div className={style.cryptoAssetsList}>
                    {loading ? (
                        <div style={{ width: "100%", textAlign: "center", padding: "40px 0" }}>
                        Loading...
                        </div>
                    ) : mappedCryptoAssets.length === 0 ? (
                        <div style={{ width: "100%", textAlign: "center", padding: "40px 0", color: "#909090" }}>
                        No crypto assets found.
                        </div>
                    ) : (
                        mappedCryptoAssets.map(asset => (
                        <div 
                            className={style.fiatAssetCard}
                            key={asset.code}
                            onClick={() => {
                            setSelectedCrypto(asset);
                            setIsCryptoModalOpen(true);
                            setWithdrawalFeeData(null);
                            setFeeError("");
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className={style.fiatAssetInfo}>
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '60px',
                                height: '60px',
                                borderRadius: '50%',
                                backgroundColor: '#FFFFFF',
                                justifyContent: 'center',
                            }}>
                                <img src={asset.icon} alt={asset.name} className={style.fiatAssetIcon} />
                            </div>
                            <div>
                                <div className={style.fiatAssetName}>{asset.name}</div>
                                <div className={style.fiatAssetSymbol}>{asset.symbol}</div>
                            </div>
                            </div>
                            <div className={style.fiatAssetPriceBlock}>
                            <div className={style.fiatAssetPrice}>{asset.price}</div>
                            <div className={asset.changeUp ? style.fiatAssetChangeUp : style.fiatAssetChangeDown}>
                                {asset.changeUp ? "↑" : "↓"} {asset.change}
                            </div>
                            </div>
                        </div>
                        ))
                    )}
                    </div>
                </>
                )}
        </>
     );
}
 
export default WithdrawPage;